import * as DeviceTypes from "../components/devices/_deviceTypes";
import {
  faAirConditioner,
  faBlinds,
  faBlindsOpen,
  faCctv,
  faCloudSun,
  faComputerSpeaker,
  faDoorOpen,
  faFlashlight,
  faHome,
  faKey,
  faLightbulb,
  faLightSwitch,
  faOutlet,
  faRaindrops,
  faSensor,
  faSensorFire,
  faServer,
  faShieldCheck,
  faSortCircle,
  faTachometerAltSlow,
  faThermometerHalf,
  faWebcam,
  faBullhorn,
  faSpeaker,
  faTint,
  faHumidity,
  faMonitorHeartRate,
  faFingerprint,
} from "../../assets/consts/faCharCodes";
export const getIconByDeviceType = (deviceType) => {
  switch (deviceType) {
    case DeviceTypes.AIR_CONDITIONER:
      return faAirConditioner;
    case DeviceTypes.AREA_STATE:
      return faHome;
    case DeviceTypes.CAMERA:
      return faCctv;
    case DeviceTypes.CURTAIN:
      return faBlinds;
    case DeviceTypes.DOORBELL:
      return faWebcam;
    case DeviceTypes.DOORLOCK:
      return faKey;
    case DeviceTypes.DOOR_SENSOR:
    case "DOOROPENING":
      return faDoorOpen;
    case DeviceTypes.ELEVATOR:
      return faSortCircle;
    case DeviceTypes.FIRE_ALARM:
      return faSensorFire;
    case DeviceTypes.HIDDEN_SWITCH:
      return faLightSwitch;
    case DeviceTypes.LIGHT:
    case DeviceTypes.LIGHT_DIMMER:
      return faLightbulb;
    case DeviceTypes.LIGHT_METER:
      return faFlashlight;
    case DeviceTypes.MOTION_SENSOR:
      return faSensor;
    case DeviceTypes.SMART_SPEAKER:
      return faSpeaker;
    case DeviceTypes.OUTLET:
      return faOutlet;
    case DeviceTypes.POWER_METER:
    case DeviceTypes.WATER_METER:
      return faTachometerAltSlow;
    case DeviceTypes.POWER_SWITCH:
      return faLightSwitch;
    case DeviceTypes.ROLLER_BLIND:
      return faBlindsOpen;
    case DeviceTypes.SENSOR:
      return faSensor;
    case DeviceTypes.TAPLIFE_CONTROLLER:
      return faServer;
    case DeviceTypes.THERMO_METER:
      return faThermometerHalf;
    case DeviceTypes.HUMIDITY_SENSOR:
      return faHumidity;
    case DeviceTypes.WATERING_SWITCH:
      return faRaindrops;
    case DeviceTypes.WEATHER:
      return faCloudSun;
    case DeviceTypes.SIREN:
      return faBullhorn;
    case "AREAARM":
      return faShieldCheck;
    case DeviceTypes.VOLTAGE_SENSOR:
      return faMonitorHeartRate;
    case DeviceTypes.ACCESS_CONTROL:
      return faFingerprint;
    default:
      return faSensor;
  }
};
